import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AwbShipmentRO, ShipmentsService } from '@app/shared/services/shipments.service';
import { AdminScopes, AdminUser, UserService } from '@app/shared/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { LoggerService } from '@app/shared/services/logger.service';
import { BannerNotificationsService } from '@app/shared/services/banner-notifications.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmationComponent } from '@app/shared/components/modal-confirmation/modal-confirmation.component';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@app/shared/components/components.module';
import { SharedModule } from '@app/shared/shared.module';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-update-shipment-awb',
  templateUrl: './update-shipment-awb.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [ComponentsModule, CommonModule, MatButton, SharedModule],
})
export class UpdateShipmentAwbComponent implements OnInit {
  public shipment: any;
  public adminUser: AdminUser;
  public form: FormGroup;
  public isUpdating: boolean = false;

  constructor(
    private shipmentsService: ShipmentsService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private logger: LoggerService,
    private bannerNotificationsService: BannerNotificationsService,
    private dialog: MatDialog,
    public drawerRef: MtxDrawerRef<UpdateShipmentAwbComponent>,
    @Inject(MTX_DRAWER_DATA)
    public data: {
      shipment: any;
      adminUser: AdminUser;
    }
  ) {}

  ngOnInit() {
    if (
      this.data &&
      this.data.shipment &&
      this.data.adminUser &&
      this.userService.hasAuthScope(this.data.adminUser, [AdminScopes.MODIFY_AWB_LABELS])
    ) {
      this.shipment = this.data.shipment;
      this.adminUser = this.data.adminUser;
      this.createForm();
    } else {
      this.dismissDrawer();
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
        newAwbNumber: ['', Validators.maxLength(250)],
    });
  }

  public submitForm() {
    if (this.form.valid && !this.isUpdating) {
      this.isUpdating = true;
      this.update(this.shipment);
    }
  }

  public update(shipment: any): void {
    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      width: '600px',
      data: {
        title: 'Update AWB number',
        content: `Are you sure you want to update the AWB number from ${shipment.airWaybill} to ${this.form.value.newAwbNumber}?`,
        btnColor: 'primary',
        confirmBtnLabel: 'Update AWB number',
      },
    });
    dialogRef.afterClosed().subscribe((isConfirmed) => {
      if (isConfirmed) {
        this.logger.log('UPDATED AWB', this.form.value.newAwbNumber);
        const params: { shipmentId: number, awbNumber: string, newAwbNumber: string } = { shipmentId: this.shipment.id, awbNumber: this.shipment.airWaybill, newAwbNumber: this.form.value.newAwbNumber };
        this.shipmentsService.updateShipmentAWB(params).subscribe(
          (res: any) => {
            this.logger.log('UPDATED AWB', res);
            this.bannerNotificationsService.success('AWB updated successfully');
            this.isUpdating = false;
            this.dismissDrawer(true);
          },
          (err: any) => {
            this.bannerNotificationsService.error('Could not update AWB', {
              category: 'UPDATED AWB error',
              message: err,
            });
            this.isUpdating = false;
          }
        );
      } else {
        this.bannerNotificationsService.success('AWB update cancelled');
        this.isUpdating = false;
      }
    });
  }

  public dismissDrawer(successful: boolean = false): void {
    this.drawerRef.dismiss(successful);
  }
}
